import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { exportLTAsToCSV, importLTA } from "common/services/ltas.service";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";
import LTAsImportModal from "./LTAsImportModal";

/**
 * Import/export menu for the LTA table.
 *
 * The service calls are injected so the agency-scoped view can point the same
 * menu at `/agency/ltas` without duplicating the component.
 */
const Import = ({
  apiParams,
  exportFn = exportLTAsToCSV,
  importFn = importLTA,
}: {
  apiParams?: any;
  exportFn?: (params: any) => Promise<any>;
  importFn?: any;
}) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportFn({
      filters: apiParams?.filters,
      sort: apiParams?.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "LTAs_Export.csv");
        link.click();
        link.remove();
      })
      .catch(() => {
        toast.error("An error occurred while exporting LTAs");
      });

    setExporting(false);
  }, [apiParams, exportFn]);

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="lta" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="lta" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <LTAsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        importFn={importFn}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default Import;
